import React from "react";

// One label-and-value row of the tenant info panel, before the tenant arrives.
// `lines` matches the number of value lines the real row will draw, so the
// panel does not jump height when it loads.
const SkeletonMetaRow = ({ lines = 2 }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="h-3 w-28 rounded bg-background-tertiary/60 animate-pulse" />
            {Array.from({ length: lines }).map((_, i) => (
                <div key={i} className="h-4 w-full rounded bg-background-tertiary/60 animate-pulse" />
            ))}
        </div>
    );
};

export default SkeletonMetaRow;
